import { render, staticRenderFns } from "./videoSearch.vue?vue&type=template&id=667ab72d&"
import script from "./videoSearch.vue?vue&type=script&lang=js&"
export * from "./videoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports